var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "149.65625pt",
    height: "149.77734pt",
    viewBox: "0 0 149.65625 149.77734",
    id: "svg572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.3125,2.828125 C 2.226562,3.015625 2.039062,3.109375 1.75,3.109375 1.664062,3.109375 1.582031,3.09375 1.5,3.0625 L 1.078125,2.953125 C 0.597656,2.828125 0.28125,2.578125 0.125,2.203125 0.0390625,2.015625 0,1.796875 0,1.546875 V 0.71875 C 0,0.582031 0.0703125,0.515625 0.21875,0.515625 c 0.132812,0 0.203125,0.066406 0.203125,0.203125 v 0.953125 c 0,0.1875 0.0625,0.359375 0.1875,0.515625 0.125,0.164062 0.28125,0.273438 0.46875,0.328125 L 1.5,2.625 c 0.09375,0.019531 0.175781,0.03125 0.25,0.03125 0.257812,0 0.390625,-0.179688 0.390625,-0.53125 V 1.75 c 0,-0.148438 0.070313,-0.21875 0.21875,-0.21875 0.144531,0 0.21875,0.070312 0.21875,0.21875 v 0.5 c 0,0.257812 0.101563,0.476562 0.3125,0.65625 C 2.992188,3 3.101562,3.0625 3.21875,3.09375 c 0.070312,0.00781 0.132812,0.015625 0.1875,0.015625 0.300781,0 0.453125,-0.171875 0.453125,-0.515625 V 1.765625 c 0,-0.148437 0.070313,-0.21875 0.21875,-0.21875 0.144531,0 0.21875,0.070313 0.21875,0.21875 v 0.9375 c 0,0.332031 -0.152344,0.582031 -0.453125,0.75 -0.136719,0.0625 -0.277344,0.09375 -0.421875,0.09375 -0.0625,0 -0.132813,-0.00781 -0.203125,-0.015625 C 2.75,3.40625 2.445312,3.171875 2.3125,2.828125 Z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.421875,1.671875 c 0,0.4375 0.21875,0.710937 0.65625,0.828125 L 1.5,2.625 c 0.082031,0.019531 0.164062,0.03125 0.25,0.03125 0.257812,0 0.390625,-0.179688 0.390625,-0.53125 V 1.453125 l -1.0625,-0.28125 C 1.003906,1.148438 0.945312,1.140625 0.90625,1.140625 0.769531,1.140625 0.65625,1.1875 0.5625,1.28125 0.46875,1.382812 0.421875,1.515625 0.421875,1.671875 Z M 0,1.546875 c 0,-0.304687 0.15625,-0.542969 0.46875,-0.71875 0.132812,-0.085937 0.273438,-0.125 0.421875,-0.125 0.0625,0 0.117187,0.007813 0.171875,0.03125 l 1.296875,0.34375 c 0.476563,0.125 0.878906,0.335937 1.203125,0.640625 0.351562,0.332031 0.59375,0.769531 0.71875,1.3125 0.00781,0.019531 0.015625,0.039062 0.015625,0.0625 0,0.132812 -0.074219,0.203125 -0.21875,0.203125 C 3.953125,3.296875 3.882812,3.25 3.875,3.15625 3.84375,2.914062 3.753906,2.675781 3.609375,2.4375 3.335938,2 2.992188,1.722656 2.578125,1.609375 V 2.25 C 2.578125,2.488281 2.5,2.6875 2.34375,2.84375 2.1875,3.007812 1.984375,3.09375 1.734375,3.09375 1.648438,3.09375 1.570312,3.082031 1.5,3.0625 L 1.078125,2.953125 C 0.578125,2.816406 0.253906,2.570312 0.109375,2.21875 0.0351562,2.039062 0,1.816406 0,1.546875 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.109375,3.03125 0.09375,1.796875 C 0.03125,1.753906 0,1.691406 0,1.609375 0,1.546875 0.0195312,1.492188 0.0625,1.453125 0.113281,1.410156 0.164062,1.390625 0.21875,1.390625 l 3.859375,0.15625 c 0.144531,0 0.21875,0.066406 0.21875,0.203125 0,0.15625 -0.078125,0.234375 -0.234375,0.234375 L 1.015625,1.84375 2.90625,3.015625 C 2.96875,3.046875 3,3.101562 3,3.1875 3,3.320312 2.9375,3.394531 2.8125,3.40625 L 0.984375,3.546875 4.171875,5.125 c 0.082031,0.039062 0.125,0.101562 0.125,0.1875 0,0.144531 -0.074219,0.21875 -0.21875,0.21875 -0.03125,0 -0.0625,-0.00781 -0.09375,-0.015625 L 0.109375,3.59375 C 0.0351562,3.550781 0,3.488281 0,3.40625 0,3.257812 0.0664062,3.1875 0.203125,3.1875 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.421875,2.5 c 0,0.144531 -0.070313,0.21875 -0.203125,0.21875 C 0.0703125,2.71875 0,2.644531 0,2.5 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 l 3.921875,1.046875 c 0.101563,0.03125 0.15625,0.101563 0.15625,0.21875 0,0.132813 -0.074219,0.203125 -0.21875,0.203125 -0.023437,0 -0.042969,0 -0.0625,0 L 0.421875,1 Z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.140625,2.640625 V 1.46875 L 0.421875,1 v 1.5 c 0,0.144531 -0.070313,0.21875 -0.203125,0.21875 C 0.0703125,2.71875 0,2.644531 0,2.5 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 l 3.859375,1.03125 c 0.144531,0.039062 0.21875,0.140625 0.21875,0.296875 V 3.53125 C 4.296875,3.675781 4.222656,3.75 4.078125,3.75 3.929688,3.75 3.859375,3.675781 3.859375,3.53125 V 1.921875 l -1.28125,-0.34375 v 1.0625 c 0,0.132813 -0.074219,0.203125 -0.21875,0.203125 -0.148437,0 -0.21875,-0.070312 -0.21875,-0.203125 z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4.078125,1.53125 c 0.144531,0.039062 0.21875,0.140625 0.21875,0.296875 V 3.15625 c 0,0.21875 -0.09375,0.410156 -0.28125,0.578125 C 3.828125,3.910156 3.617188,4 3.390625,4 3.328125,4 3.269531,3.992188 3.21875,3.984375 L 1.078125,3.40625 C 0.359375,3.207031 0,2.738281 0,2 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 Z M 3.859375,1.921875 0.421875,1 v 1.109375 c 0,0.1875 0.0625,0.359375 0.1875,0.515625 0.125,0.164062 0.28125,0.273438 0.46875,0.328125 L 3.21875,3.53125 C 3.269531,3.539062 3.320312,3.546875 3.375,3.546875 3.519531,3.546875 3.632812,3.5 3.71875,3.40625 3.8125,3.3125 3.859375,3.1875 3.859375,3.03125 Z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.71875,4.28125 H 0 V 0.25 c 0.175781,0 0.347656,0.03125 0.515625,0.09375 0.28125,0.101562 0.550781,0.265625 0.8125,0.484375 C 1.597656,1.054688 1.90625,1.382812 2.25,1.8125 c 0.539062,0.664062 0.96875,1.113281 1.28125,1.34375 0.320312,0.238281 0.625,0.359375 0.90625,0.359375 0.300781,0 0.550781,-0.109375 0.75,-0.328125 C 5.394531,2.976562 5.5,2.703125 5.5,2.359375 5.5,2.003906 5.390625,1.71875 5.171875,1.5 4.960938,1.28125 4.664062,1.171875 4.28125,1.171875 L 4.359375,0.40625 C 4.929688,0.457031 5.367188,0.65625 5.671875,1 5.972656,1.34375 6.125,1.800781 6.125,2.375 6.125,2.957031 5.957031,3.421875 5.625,3.765625 5.300781,4.109375 4.898438,4.28125 4.421875,4.28125 4.179688,4.28125 3.941406,4.226562 3.703125,4.125 3.472656,4.03125 3.226562,3.863281 2.96875,3.625 2.707031,3.394531 2.347656,3.015625 1.890625,2.484375 1.515625,2.023438 1.257812,1.734375 1.125,1.609375 0.988281,1.484375 0.851562,1.378906 0.71875,1.296875 Z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3,0.359375 c 0.726562,0 1.3125,0.070313 1.75,0.21875 0.4375,0.144531 0.773438,0.363281 1.015625,0.65625 C 6.003906,1.523438 6.125,1.894531 6.125,2.34375 6.125,2.664062 6.054688,2.953125 5.921875,3.203125 5.785156,3.453125 5.59375,3.65625 5.34375,3.8125 5.101562,3.96875 4.800781,4.09375 4.4375,4.1875 4.082031,4.28125 3.601562,4.328125 3,4.328125 2.289062,4.328125 1.710938,4.253906 1.265625,4.109375 0.828125,3.960938 0.488281,3.742188 0.25,3.453125 0.0078125,3.160156 -0.109375,2.789062 -0.109375,2.34375 -0.109375,1.75 0.101562,1.285156 0.53125,0.953125 1.03125,0.554688 1.851562,0.359375 3,0.359375 Z M 3,1.125 C 2,1.125 1.332031,1.238281 1,1.46875 0.675781,1.707031 0.515625,2 0.515625,2.34375 c 0,0.34375 0.164063,0.628906 0.5,0.859375 C 1.347656,3.441406 2.007812,3.5625 3,3.5625 4.007812,3.5625 4.675781,3.441406 5,3.203125 5.332031,2.972656 5.5,2.679688 5.5,2.328125 5.5,1.984375 5.351562,1.710938 5.0625,1.515625 4.6875,1.253906 4,1.125 3,1.125 Z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0.625 h 6.09375 v 0.8125 h -5.375 v 3 H 0 Z m 0,0",
    id: "path9"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g575",
    transform: "translate(-135.89062,-12.050781)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,8.34667e-4 H -34.719594 m -5.28125,0 h -5.119792 m -5.119792,0 h -5.28125 m -5.119791,0 h -25.916667 m -5.119792,0 h -5.28125 m -5.119792,0 h -5.28125 m -5.11979,0 h -25.92188 m -5.11979,0 h -5.27604 m -5.11979,0 h -5.125",
    transform: "matrix(0.75,0,0,0.75,285.36001,161.64)",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 216.16146,215.52084 H 181.4375 v -34.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.002502,8.34667e-4 V -5.118957 m 0,-5.28125 v -5.119792 m 0,-5.28125 v -25.760416 m 0,-5.276042 v -5.119792 m 0,-5.28125 v -5.119791 m 0,-5.119792 v -25.921875 m 0,-5.281253 v -5.11979 m 0,-5.11979 v -5.28125",
    transform: "matrix(0.75,0,0,0.75,136.08,131.64)",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 181.4375,51.197922 V 16.317714 h 34.72396",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.002502,-0.00228633 h 5.125 m 5.119792,0 h 5.276041 m 5.119792,0 h 25.921875 m 5.119792,0 h 5.28125 m 5.119791,0 h 5.28125 m 5.119792,0 H 98.39854 m 5.11979,0 h 5.28125 m 5.11979,0 h 5.11979",
    transform: "matrix(0.75,0,0,0.75,166.08,12.239996)",
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 345.76042,16.317714 h 34.71875 v 34.880208",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,-0.00228633 V 5.278964 m 0,5.119791 v 5.119792 m 0,5.28125 v 25.921875 m 0,5.119792 v 5.119791 m 0,5.28125 v 5.119792 m 0,5.276042 v 25.760416 m 0,5.281245 v 5.1198 m 0,5.28125 v 5.11979",
    transform: "matrix(0.75,0,0,0.75,285.36001,42.239996)",
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 380.47917,180.64063 v 34.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 285.35937,12.238281 285.23828,23.28125 V 12.238281 Z m 0,0",
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 285.35937,12.238281 V 23.28125 h -0.12109 z m 0,0",
    id: "path99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,23.160156 -1.67969,0.121094 v -0.121094 z m 0,0",
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,23.160156 v 0.121094 h -1.67969 z m 0,0",
    id: "path101"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 283.55859,21.71875 -0.23828,1.5625 v -1.5625 z m 0,0",
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 283.55859,21.71875 v 1.5625 h -0.23828 z m 0,0",
    id: "path103"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 277.80078,14.160156 -1.44141,0.121094 v -0.121094 z m 0,0",
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 277.80078,14.160156 v 0.121094 h -1.44141 z m 0,0",
    id: "path105"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,12.238281 -8.87891,0.242188 v -0.242188 z m 0,0",
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,12.238281 v 0.242188 h -8.87891 z m 0,0",
    id: "path107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 276.35937,12.238281 -0.12109,2.042969 v -2.042969 z m 0,0",
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 276.35937,12.238281 v 2.042969 h -0.12109 z m 0,0",
    id: "path109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00228633 H 12.15916 m -12,0.32291633 H 11.997701 M 12.15916,-0.00228633 V 14.721672 M 11.997701,0.32063 v 14.239584 m 0.161459,0.161458 H 9.44041 m 2.557291,-0.161458 H 9.758118 M 9.44041,14.721672 v -2.083333 m 0.317708,1.921875 V 12.638339 M -0.00229867,-0.00228633 V 2.721672 M 0.15916,0.32063 V 2.560214 M -0.00229867,2.721672 H 2.081035",
    transform: "matrix(0.75,0,0,0.75,276.24,12.239996)",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 368.47917,18.880214 h 1.92187 v 0.161458",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,-0.00166033 H -0.31957 M -3.361237,-9.918327 v 0.958333 m 0,0.161459 v 0.958333 m 0,0.317708 v 0.963542 m 0,0.317708 v 0.963542 m 0,0.15625 v 0.963542 m 0,0.317708 v 0.958333",
    transform: "matrix(0.75,0,0,0.75,283.55999,21.719995)",
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 374.71875,26.401047 v 0.796875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,-0.00166033 H 0.962494 m 0.15625,0 h 1.119792 m 0.161458,0 h 0.958333 m 0.322917,0 h 0.958333 m 0.161459,0 h 0.958333 m 0.322917,0 h 0.958333",
    transform: "matrix(0.75,0,0,0.75,277.2,21.719995)",
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 376.95833,28.958339 h 0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path115"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.07812,12.238281 0.1211,11.042969 V 12.238281 Z m 0,0",
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "M 136.07812,12.238281 V 23.28125 h 0.1211 z m 0,0",
    id: "path117"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.19922,23.160156 1.67969,0.121094 v -0.121094 z m 0,0",
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.19922,23.160156 v 0.121094 h 1.67969 z m 0,0",
    id: "path119"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 137.87891,21.71875 0.24218,1.5625 v -1.5625 z m 0,0",
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 137.87891,21.71875 v 1.5625 h 0.24218 z m 0,0",
    id: "path121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 143.64062,14.160156 1.4375,0.121094 v -0.121094 z m 0,0",
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 143.64062,14.160156 v 0.121094 h 1.4375 z m 0,0",
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.19922,12.238281 8.8789,0.242188 v -0.242188 z m 0,0",
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.19922,12.238281 v 0.242188 h 8.8789 z m 0,0",
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.07812,12.238281 0.1211,2.042969 v -2.042969 z m 0,0",
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.07812,12.238281 v 2.042969 h 0.1211 z m 0,0",
    id: "path127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,-0.00228633 H -12.162506 m 12,0.32291633 h -11.838542 m -0.161458,-0.32291633 V 14.721672 M -12.001048,0.32063 v 14.239584 m -0.161458,0.161458 h 2.723958 m -2.5625,-0.161458 h 2.239584 m 0.322916,0.161458 v -2.083333 m -0.322916,1.921875 V 12.638339 M -0.00104767,-0.00228633 V 2.721672 M -0.162506,0.32063 v 2.239584 m 0.16145833,0.161458 H -2.079173",
    transform: "matrix(0.75,0,0,0.75,145.2,12.239996)",
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 193.4375,18.880214 h -1.91667 v 0.161458",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,-0.00166033 H 0.321462 M 3.201671,-9.918327 v 0.958333 m 0,0.161459 v 0.958333 m 0,0.317708 v 0.963542 m 0,0.317708 v 0.963542 m 0,0.15625 v 0.963542 m 0,0.317708 v 0.958333",
    transform: "matrix(0.75,0,0,0.75,137.88,21.719995)",
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 187.04167,26.401047 v 0.796875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-0.00166033 H -0.960632 m -0.317708,0 h -0.963542 m -0.15625,0 h -0.963542 m -0.317708,0 h -0.958333 m -0.161459,0 h -1.119791 m -0.161459,0 h -0.958333",
    transform: "matrix(0.75,0,0,0.75,144.24,21.719995)",
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 184.95833,28.958339 h -0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.35937,161.64062 -0.12109,-11.03906 v 11.03906 z m 0,0",
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.35937,161.64062 v -11.03906 h -0.12109 z m 0,0",
    id: "path135"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,150.71875 -1.67969,-0.11719 v 0.11719 z m 0,0",
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,150.71875 v -0.11719 h -1.67969 z m 0,0",
    id: "path137"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 283.55859,152.16016 -0.23828,-1.5586 v 1.5586 z m 0,0",
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 283.55859,152.16016 v -1.5586 h -0.23828 z m 0,0",
    id: "path139"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 277.80078,159.71875 -1.44141,-0.11719 v 0.11719 z m 0,0",
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 277.80078,159.71875 v -0.11719 h -1.44141 z m 0,0",
    id: "path141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,161.64062 -8.87891,-0.24218 v 0.24218 z m 0,0",
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 285.23828,161.64062 v -0.24218 h -8.87891 z m 0,0",
    id: "path143"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 276.35937,161.64062 -0.12109,-2.03906 v 2.03906 z m 0,0",
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 276.35937,161.64062 v -2.03906 h -0.12109 z m 0,0",
    id: "path145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,8.34667e-4 H 12.15916 m -12,-0.322916667 H 11.997701 M 12.15916,8.34667e-4 V -14.717915 m -0.161459,14.395833 v -14.239583 m 0.161459,-0.15625 H 9.44041 m 2.557291,0.15625 H 9.758118 m -0.317708,-0.15625 v 2.078125 m 0.317708,-1.921875 v 1.921875 M -0.00229867,8.34667e-4 V -2.717915 M 0.15916,-0.322082 v -2.239583 m -0.16145867,-0.15625 H 2.081035",
    transform: "matrix(0.75,0,0,0.75,276.24,161.64)",
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 368.47917,212.95834 h 1.92187 v -0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,2.08667e-4 H -0.31957 M -3.361237,9.922084 V 8.958542 m 0,-0.15625 V 7.83875 m 0,-0.317708 V 6.5575 m 0,-0.317708 V 5.281459 m 0,-0.161459 V 4.161667 m 0,-0.322917 V 2.880417",
    transform: "matrix(0.75,0,0,0.75,283.55999,152.16)",
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 374.71875,205.4375 v -0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,2.08667e-4 H 0.962494 m 0.15625,0 h 1.119792 m 0.161458,0 h 0.958333 m 0.322917,0 h 0.958333 m 0.161459,0 h 0.958333 m 0.322917,0 h 0.958333",
    transform: "matrix(0.75,0,0,0.75,277.2,152.16)",
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 376.95833,202.88021 h 0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path151"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.07812,161.64062 0.1211,-11.03906 v 11.03906 z m 0,0",
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.07812,161.64062 v -11.03906 h 0.1211 z m 0,0",
    id: "path153"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.19922,150.71875 1.67969,-0.11719 v 0.11719 z m 0,0",
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.19922,150.71875 v -0.11719 h 1.67969 z m 0,0",
    id: "path155"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 137.87891,152.16016 0.24218,-1.5586 v 1.5586 z m 0,0",
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 137.87891,152.16016 v -1.5586 h 0.24218 z m 0,0",
    id: "path157"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 143.64062,159.71875 1.4375,-0.11719 v 0.11719 z m 0,0",
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 143.64062,159.71875 v -0.11719 h 1.4375 z m 0,0",
    id: "path159"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.19922,161.64062 8.8789,-0.24218 v 0.24218 z m 0,0",
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 136.19922,161.64062 v -0.24218 h 8.8789 z m 0,0",
    id: "path161"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.07812,161.64062 0.1211,-2.03906 v 2.03906 z m 0,0",
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 145.07812,161.64062 v -2.03906 h 0.1211 z m 0,0",
    id: "path163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,8.34667e-4 H -12.162506 m 12,-0.322916667 H -12.001048 M -12.162506,8.34667e-4 V -14.717915 m 0.161458,14.395833 v -14.239583 m -0.161458,-0.15625 h 2.723958 m -2.5625,0.15625 h 2.239584 m 0.322916,-0.15625 v 2.078125 m -0.322916,-1.921875 v 1.921875 M -0.00104767,8.34667e-4 V -2.717915 M -0.162506,-0.322082 v -2.239583 m 0.16145833,-0.15625 H -2.079173",
    transform: "matrix(0.75,0,0,0.75,145.2,161.64)",
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 193.4375,212.95834 h -1.91667 v -0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path165"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00145433,2.08667e-4 H 0.321462 M 3.201671,9.922084 V 8.958542 m 0,-0.15625 V 7.83875 m 0,-0.317708 V 6.5575 m 0,-0.317708 V 5.281459 m 0,-0.161459 V 4.161667 m 0,-0.322917 V 2.880417",
    transform: "matrix(0.75,0,0,0.75,137.88,152.16)",
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 187.04167,205.4375 v -0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,2.08667e-4 H -0.960632 m -0.317708,0 h -0.963542 m -0.15625,0 h -0.963542 m -0.317708,0 h -0.958333 m -0.161459,0 h -1.119791 m -0.161459,0 h -0.958333",
    transform: "matrix(0.75,0,0,0.75,144.24,152.16)",
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 184.95833,202.88021 h -0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path169"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 284,67.041672 v 97.916668 h -6.07813 V 67.041672 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path374"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.00145433,0.001671 -0.47916667,-0.640625 -0.796875,-0.479167 -0.802083,-0.322916 -0.802084,-0.161459 -0.796875,0.161459 -0.802083,0.322916 -0.796875,0.479167 -0.484375,0.640625",
    transform: "matrix(0.75,0,0,0.75,212.88,50.279997)",
    id: "path375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,0.00208567 0.482513,0.637502 1.279388,1.121877 2.081471,1.439586 2.878346,1.601044 3.68043,1.439586 4.482513,1.121877 5.279388,0.637502 5.758555,0.00208567",
    transform: "matrix(0.75,0,0,0.75,208.55999,123.6)",
    id: "path376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 280.95833,67.041672 V 164.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path377"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g377"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 214.31696,
    y: 73.078941,
    id: "use377"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 3734.625,-10658.249 c 9.2251,4.228 13.8377,13.453 13.8377,27.676 0,4.228 -0.7688,8.264 -2.3063,12.3 l -5.3813,20.756 c -6.1501,23.639 -18.4502,39.207 -36.9004,46.894 -9.2251,4.228 -19.9877,6.15 -32.2878,6.15 h -40.7441 c -6.7267,0 -9.9939,-3.459 -9.9939,-10.762 0,-6.535 3.2672,-9.994 9.9939,-9.994 h 46.8942 c 9.2251,0 17.6814,-3.075 25.369,-9.225 8.0719,-6.15 13.4532,-13.838 16.1439,-23.063 l 5.3813,-20.756 c 0.9609,-4.613 1.5375,-8.649 1.5375,-12.3 0,-12.685 -8.8407,-19.219 -26.1378,-19.219 h -18.4501 c -7.3032,0 -10.7626,-3.46 -10.7626,-10.763 0,-7.111 3.4594,-10.763 10.7626,-10.763 h 24.6002 c 12.6845,0 23.4471,-4.997 32.2878,-15.375 4.6126,-4.997 7.6876,-10.378 9.2251,-16.144 0.3844,-3.459 0.7688,-6.534 0.7688,-9.225 0,-14.798 -8.4564,-22.294 -25.369,-22.294 h -40.7442 c -7.3032,0 -10.7626,-3.459 -10.7626,-10.762 0,-7.111 3.4594,-10.763 10.7626,-10.763 h 46.1255 c 16.3361,0 28.6362,7.495 36.9004,22.294 3.075,6.727 4.6125,13.645 4.6125,20.756 0,3.075 -0.3844,6.535 -0.7688,9.994 -6.15,23.063 -17.6814,38.054 -34.5941,44.588 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path378"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g378"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 214.31696,
    y: 76.198906,
    id: "use378"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 3831.2963,-10565.229 c 21.5252,0 34.9785,-10.763 40.7442,-32.288 l 6.15,-20.756 c 0.961,-4.036 1.5376,-8.072 1.5376,-12.3 0,-12.685 -8.8408,-19.219 -26.1378,-19.219 h -33.0566 l -13.8376,52.275 c -1.1532,3.652 -1.5375,6.535 -1.5375,8.456 0,6.727 2.3062,12.301 6.9188,16.913 4.9969,4.613 11.5313,6.919 19.2189,6.919 z m -6.15,20.756 c -14.9908,0 -26.7144,-7.687 -35.3629,-23.062 -4.2282,-6.535 -6.1501,-13.454 -6.1501,-20.757 0,-3.075 0.3844,-5.766 1.5376,-8.456 l 16.9126,-63.807 c 6.1501,-23.447 16.5283,-43.243 31.5191,-59.194 16.3361,-17.297 37.8613,-29.213 64.5756,-35.363 0.961,-0.385 1.9219,-0.769 3.0751,-0.769 6.5344,0 9.9938,3.652 9.9938,10.763 0,6.15 -2.3063,9.609 -6.9188,9.993 -11.9157,1.538 -23.6393,5.958 -35.3629,13.069 -21.5252,13.454 -35.1706,30.366 -40.7441,50.738 h 31.5191 c 11.7235,0 21.5252,3.844 29.2127,11.532 8.072,7.687 12.3002,17.681 12.3002,29.981 0,4.228 -0.5766,8.072 -1.5375,11.532 l -5.3813,20.756 c -6.7267,24.6 -18.8346,40.552 -36.1317,47.663 -8.8407,3.652 -19.7955,5.381 -33.0565,5.381 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path379"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g379"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 214.31696,
    y: 79.198875,
    id: "use379"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 4045.7797,-10648.255 -60.7318,99.17 c -2.1141,3.075 -5.1892,4.612 -9.2251,4.612 -3.0751,0 -5.7657,-0.961 -7.6876,-3.075 -2.1141,-2.498 -3.075,-4.997 -3.075,-7.687 l 7.6875,-189.883 c 0,-7.111 3.2673,-10.763 9.9939,-10.763 7.6876,0 11.5314,3.844 11.5314,11.531 l -6.9189,149.908 57.6569,-93.02 c 1.5375,-3.075 4.2281,-4.612 8.4563,-4.612 6.5344,0 10.186,3.075 10.7626,9.225 l 6.9188,89.945 77.6445,-156.827 c 1.9219,-4.036 4.997,-6.15 9.2251,-6.15 7.111,0 10.7626,3.652 10.7626,10.763 0,1.537 -0.3843,3.075 -0.7687,4.612 l -94.5572,190.652 c -2.1141,3.652 -5.1891,5.381 -9.2251,5.381 -7.3032,0 -10.7626,-3.267 -10.7626,-9.993 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path380"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g380"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 214.43689,
    y: 88.080421,
    id: "use380"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 4456.6807,-10571.187 c 7.111,0 10.7626,3.459 10.7626,9.994 0,7.303 -3.6516,10.762 -10.7626,10.762 h -89.9446 c -3.0751,0 -5.7657,-0.96 -7.6876,-3.075 -1.5375,-1.921 -1.9219,-4.612 -0.7688,-7.687 l 51.5068,-192.958 c 1.5375,-4.997 4.9969,-7.688 10.7626,-7.688 6.5344,0 9.9938,3.652 9.9938,10.763 0,1.153 0,2.114 0,3.075 l -47.6629,176.814 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path381"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g381"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 214.43689,
    y: 91.080391,
    id: "use381"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 4611.201,-10655.75 h -57.6568 l -23.0628,84.563 h 73.8008 c 7.111,0 10.7626,3.459 10.7626,9.994 0,7.303 -3.6516,10.762 -10.7626,10.762 h -89.9447 c -3.075,0 -5.7657,-0.96 -7.6875,-3.075 -1.5376,-1.921 -1.9219,-4.612 -0.7688,-7.687 l 50.738,-189.883 c 1.9219,-7.111 6.9188,-10.763 14.6064,-10.763 h 83.7946 c 7.111,0 10.7626,3.652 10.7626,10.763 0,7.303 -3.6516,10.762 -10.7626,10.762 h -79.1821 l -16.9126,63.038 h 52.2755 c 6.5344,0 9.9938,3.652 9.9938,10.763 0,7.303 -3.4594,10.763 -9.9938,10.763 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path382"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g382"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 214.43689,
    y: 94.08036,
    id: "use382"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 4704.2207,-10751.076 c 1.9219,-7.111 6.9188,-10.763 14.6064,-10.763 h 65.3444 c 10.7626,0 20.1799,4.613 28.444,13.838 8.6485,9.225 13.0689,19.603 13.0689,30.75 0,3.075 -0.3844,5.958 -0.7688,8.456 l -28.444,105.32 c -9.8017,35.363 -32.8644,53.044 -69.1882,53.044 h -65.3444 c -3.075,0 -5.7657,-0.96 -7.6876,-3.075 -1.5375,-1.921 -1.9219,-4.612 -0.7687,-7.687 z m 19.2189,10.762 -45.3567,169.127 h 54.5818 c 9.2251,0 17.6814,-3.075 25.369,-9.225 8.072,-6.15 13.4533,-13.838 16.1439,-23.063 l 28.4441,-105.32 c 0.3843,-2.498 0.7687,-4.997 0.7687,-7.687 0,-7.111 -2.3063,-12.685 -6.9188,-16.913 -4.6125,-4.612 -10.7626,-6.919 -18.4502,-6.919 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 291.83854,117.43751 v 14.72395 h -6.23958 v -14.72395 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/План Коридорний - х1.f5da0e3a46c877f46b1b6a5ed904b17a.svg";
export { ForwardRef as ReactComponent };